import { Meta } from "@/shared/components";
import { AssistantUsage } from "@/admin/features/assistantUsage";

export function AssistantUsagePage() {
  return (
    <>
      <Meta title="Расход помощника" />
      <AssistantUsage />
    </>
  );
}
